import styled from '@emotion/styled'
import { Carousel } from '@mantine/carousel'
import { rem } from '@mantine/core'

export const StyledCarouselControlInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledCarouselTag = styled(Carousel)`
  .mantine-Carousel-controls {
    padding: 0;
    top: 0;
    bottom: 0;
    inset: -1px;
  }

  .mantine-Carousel-control {
    padding-inline: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    opacity: 100%;
    outline: none;
    position: relative;
    height: 100%;
    width: auto;
    background-color: transparent;
    border-radius: none;
    border: none;
    box-shadow: none;

    &[data-inactive] {
      opacity: 0;
      pointer-events: none;
      cursor: default;
    }

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      left: 0;
      top: 0;
      bottom: 0;
      pointer-events: none;
      width: ${rem(70)};
      background-image: linear-gradient(to right, white 30%, transparent);
    }

    + .mantine-Carousel-control {
      justify-content: flex-end;
      &:before {
        left: unset;
        right: 0;
        background-image: linear-gradient(to left, white 30%, transparent);
      }
    }
  }

  .carouselTagControlIcon {
    font-size: ${rem(24)};
  }
`
